// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"6b50fd18","1281":"0a90dd33"}[chunkId] + ".chunk.css";
};